<template>
    <div>
        <v-container fill-height fluid>
            <v-row>
                <v-col cols="6" class="pa-0">
                    <AuthSidebar/>
                </v-col>
                <v-col cols="6" class="pa-0">
                <div class="right-section">
                    <div class="flex-direction-box">
                            <div class="login-from vertical-center">
                                <h1 style="margin-left: 10px">Setup Your Password</h1>
                                <!-- <p class="gray--text">{{ $t("login.welInfo") }}</p> -->
                                <form>
                                    <v-card-text>
                                        <v-row>
                                            <v-col  cols="20">
                                                <div class="subtitle">New Password<span class="red--text">*</span></div>
                                                <v-text-field
                                                    type="password"
                                                    outlined
                                                    dense
                                                    v-model="newPassword"
                                                    :rules="rules.password"
                                                    placeholder="Enter your password"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="20">
                                                <div class="subtitle">Confirm Password<span class="red--text">*</span></div>
                                                <v-text-field
                                                    type="password"
                                                    outlined
                                                    dense
                                                    v-model="confirmPassword"
                                                    :rules="rules.confirmPassword"
                                                    placeholder="Confirm password"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-card-actions >
                                        <v-row >
                                            <v-col align="center">
                                                <v-btn
                                                    style="margin-left:8px"
                                                    block
                                                    color="primary"
                                                >
                                                CONTINUE
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </form>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import countries from "@/constants/countries.js"
import AuthSidebar from "./AuthSidebar.vue"
import UserService from "@/_services/UserService"
// import MobileRegister from "./MobileRegister.vue";

  export default {
	mounted() {
		if(this.$route.params.type && (this.$route.params.type || this.$route.params.type == 'mobile')){
			this.registerType = this.$route.params.type;
		}
        this.id=this.$route.params.id;
        console.log("---> ", this.id)
	},
	watch: {
		'$route.params.type': {
			handler: function(type) {
				this.registerType = type;
			},
			deep: true,
			immediate: true
		}
	},
	components: {
		AuthSidebar,
		// MobileRegister
	},
	computed: {
		isAuthErr() {
			return this.authErr.length > 0;
		}
	},
    data() {
      return {
        id: null,
		error: false,
		registerType: null,
        countries,
        checkbox: false,
        dialog: false,
        newPassword: "",
        confirmPassword: "",
            rules: {
                name: [
                    v => !!v || 'Name is required',
                    v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                email: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                ],
                password: [
                    v => !!v || 'Password is required',
                ],
                confirmPassword: [
                    v => !!v || 'Confirm Password is required',
                    v => (this.confirmPassword === v) || 'Passwords should be same.'
                ],
            },
      }
    },
    methods: {
        openDialog() {
            this.dialog = false;
        },
        setPassword(){
            const data = {
                password: this.newPassword,
                confirmPassword: this.confirmPassword
            }
            this.startLoading();
            UserService.setPassword(this.id, data)
            .then(res => {
                if(res.code == 200 && res.success == true){
                    this.dialog = true;
                    this.$notify({
                        title: res.message,
                        type: 'success'
                    });
                }else{
                    this.$notify({
                        title: res.message.errors[0].msg,
                        type: 'error'
                    });
                }
                this.stopLoading();
            })
            .catch(err => {
                console.log('rrr', err);
                this.stopLoading();
            })
        }
    },
    mixins: [loadingMixin, generalMixin]
  };
</script>

<style scoped lang="scss">

.right-section {
	padding: 6px 20px;
	background-color: white;
	height: 100vh;
}
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.right-section .login-details {
	text-align: end;
}
.right-section .login-details h2 {
	font-size: 14px;
	font-family: pop_regular;
	font-weight: 100;
}
.right-section .login-details h2 a {
	color: #AABDCF;
	font-family: pop_semiBold;
	text-decoration: none;
	margin-left: 4px;
}
.right-section .login-from h2{
	font-size:30px;
	font-family: pop_semiBold;
	font-weight: 600;
	margin-bottom: 0px
}
.right-section .login-from p{
	color:#AABDCF;
	font-size: 12px;
	font-family: pop_regular;
	width: 308px;
	margin-top: 3px;
}
.flex-direction-box {
	height: 546px;
	max-height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
    margin-left: -150px;
}
.login-from-fill label {
	display: inline-block;
	margin-bottom: .5rem;
	color: #97A8B8;
	font-size: 14px;
	font-family: Poppins-Medium;
	letter-spacing: 0.5px;  
}
.login-from-fill .form-control {
	display: block;
	width: 100%;
	height: calc(1.5em + .75rem + 2px);
	padding: .375rem .75rem;
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
	transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
	background: #E7F0F8;
	border: 1px solid #C7D5E1;
	border-radius: 3px;
}
.login-from-fill {
	margin-top: 31px;
}

.login-from-fill .forget{
	font-size: 14px;
	font-family: Poppins-Medium;
	text-decoration: none;
	display: block;
	margin-top: 9px;
}


/*forgot css*/
.login-from-fill .form-group.phone-number {
	display: flex;
}
.login-from-fill .number-list {
	width: 52px;
	padding: 6px 4px;
	border-radius: 3px 0px 0px 3px;
	background: #AABDCF;
	color: #fff;
	font-size: 13px;
	height: 38px;
	border: 0px;
}
.login-from-fill .form-control.phone-control {
	margin: 0px;
	border-radius: 0px 3px 3px 0px;
}
select:focus-visible {
	outline: none;
}
input.form-control:focus-visible {
	outline: none;
}
.form-control::placeholder{
	font-size: 13px;
	font-family: pop_regular;
}
.login-from .emailgroup .form-control::placeholder{
	font-size: 13px;
	font-family: pop_semiBold;
}

</style>
